/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeterAccuracyClass = {
    NotSpecified: 'NotSpecified',
    A: 'A',
    B: 'B',
    C: 'C',
    ZeroPointTwoS: 'ZeroPointTwoS',
    ZeroPointFive: 'ZeroPointFive',
} as const;
export type MeterAccuracyClass = typeof MeterAccuracyClass[keyof typeof MeterAccuracyClass];

